<template>
  <div class="flex flex-col gap-3 pt-5">
    <p>Please enter any comments you wish to be included in the email.</p>
    <Textarea v-model="message" class="w-full" rows="10" auto-resize></Textarea>
    <SubmitOptions @cancelled="emit('cancelled')" @submitted="emit('submitted', message)"></SubmitOptions>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  submitted: [message: string];
  cancelled: [];
}>();

const message = ref("");
</script>
